import { useSnackbarMessageActionsContext } from "../context";

export const useRemoveSnackbarMessage = () => {
  const context = useSnackbarMessageActionsContext();

  if (!context) {
    throw new Error(
      "useRemoveSnackbarMessage must be used within a SnackbarMessageActionsContext",
    );
  }

  return context.removeMessage;
};
